import { statusTransitionFunction } from '@/modules/FileDetail/queries/statusTransition/statusTransitionQueryFunction.ts';
// import { statusTransitionQueryGenerator } from '@/modules/FileDetail/queries/statusTransition/statusTransitionQueryGenerator';
// import { getNextPage } from '@/modules/FileList/utils/getNextPage';
import { queryOptions } from '@tanstack/react-query';
import { statusTransitionQueryGenerator } from './statusTransitionQueryGenerator';

export const statusTransitionQueryOptions = (id: string) =>
  queryOptions({
    queryKey: ['status_transition', id],
    queryFn: () => statusTransitionFunction({ id }),
    select: (data) => statusTransitionQueryGenerator(data),
    // initialPageParam: 1,
    // getNextPageParam: getNextPage,
  });
